import { lazy } from 'react';

export default [
  {
    path: '/',
    exact: true,
    data: 'pages.home',
    showInNav: false,
    navName: 'Episodes',
    component: lazy(() => import('../pages/Home/Home'))
  },
  {
    path: '/episodes/steak-and-risotto',
    data: 'episodes.steakAndRisotto',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/eggplant-involtini',
    data: 'episodes.eggplantInvoltini',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/cacio-e-pepe',
    data: 'episodes.cacioEPepe',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/mushroom-pot-pie',
    data: 'episodes.mushroomPotPie',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/sorghum-glazed-branzino',
    data: 'episodes.sorghumGlazedBranzino',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/sorghum-glazed-branzino',
    data: 'episodes.sorghumGlazedBranzino',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/potato-gnocchi',
    data: 'episodes.potatoGnocchi',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/lemon-chicken',
    data: 'episodes.lemonChicken',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/gaeng-phet',
    data: 'episodes.gaengPhet',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/pork-belly',
    data: 'episodes.porkBelly',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/episodes/native-ragout',
    data: 'episodes.nativeRagout',
    exact: false,
    component: lazy(() => import('../pages/Episodes/EpisodeDetail'))
  },
  {
    path: '/recipes',
    data: 'pages.recipes',
    exact: true,
    showInNav: true,
    navName: 'Recipes',
    component: lazy(() => import('../pages/Recipes/Recipes'))
  },
  {
    path: '/recipes/steak-and-risotto',
    data: 'recipes.steakAndRisotto',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/eggplant-involtini',
    data: 'recipes.eggplantInvoltini',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/cacio-e-pepe',
    data: 'recipes.cacioEPepe',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/mushroom-pot-pie',
    data: 'recipes.mushroomPotPie',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/sorghum-glazed-branzino',
    data: 'recipes.sorghumGlazedBranzino',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/potato-gnocchi',
    data: 'recipes.potatoGnocchi',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/lemon-chicken',
    data: 'recipes.lemonChicken',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/gaeng-phet',
    data: 'recipes.gaengPhet',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/pork-belly',
    data: 'recipes.porkBelly',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/recipes/native-ragout',
    data: 'recipes.nativeRagout',
    exact: true,
    component: lazy(() => import('../pages/Recipes/RecipeDetail'))
  },
  {
    path: '/meet-the-chefs',
    data: 'pages.meetTheChefs',
    exact: true,
    showInNav: false,
    navName: 'Meet the Chefs',
    component: lazy(() => import('../pages/MeetTheChefs/MeetTheChefs'))
  },
  {
    path: '/cooking-with-gas',
    data: 'pages.cookingWithGas',
    exact: true,
    showInNav: true,
    navName: 'Cooking with Gas',
    component: lazy(() => import('../pages/CookingWithGas/CookingWithGas'))
  },
  {
    path: '/styleguide',
    data: 'pages.styleguide',
    exact: true,
    component: lazy(() => import('../pages/Styleguide/Styleguide'))
  },
  {
    //404 needs to be at bottom or it will overwrite others
    path: null,
    data: 'pages.notFound',
    component: lazy(() => import('../pages/NotFound/NotFound'))
  }
];
